import axios from "axios";
const awsLambdUrl = 'https://ztb427bq55.execute-api.ap-south-1.amazonaws.com/PROD'
const saveItCareerFormURL = "https://mcih84roig.execute-api.ap-south-1.amazonaws.com/PROD/pagewisecms"
const enquiryFormURL = "https://oapa1dlg23.execute-api.ap-south-1.amazonaws.com/PROD/lakmeenquireform"
const schedulerUrl =  "https://kd1bfxizi2.execute-api.ap-south-1.amazonaws.com/lakme-Prod/rotator"

export function schedulerData(postData) {
  // console.log(enquiryFormURL, postData)
  return axios.post(schedulerUrl, postData)
    .then((data) => data)
    .then((res) => res)
}
export function enquiryForm(postData) {
  console.log(enquiryFormURL, postData)
  return axios.post(enquiryFormURL, postData)
    .then((data) => data)
    .then((res) => res)
}
export function saveItCareerForm(postData) {
  console.log(saveItCareerFormURL, postData)
  return axios.post(saveItCareerFormURL, postData)
    .then((data) => data)
    .then((res) => res)
}

const deleteAwardURL = awsLambdUrl + '/getdetails'
export function dataUpdate(postData) {
  return axios.post(deleteAwardURL, postData)
    .then((data) => data)
    .then((res) => res)
}
const getawscredentialURL = awsLambdUrl + '/getdetails'
export function getawscredentials(postData) {
  return axios.post(getawscredentialURL, postData)
    .then((data) => data)
    .then((res) => res)
}
const deleteAwardURLCourse = awsLambdUrl + '/getdetails'
export function getCourseList(postData) {
  return axios.post(deleteAwardURLCourse, postData)
    .then((data) => data)
    .then((res) => res)
}
const deleteAwardURLCourseCity = awsLambdUrl + '/getdetails'
export function getCourseCityList(postDataCity) {
  return axios.post(deleteAwardURLCourseCity, postDataCity)
    .then((data) => data)
    .then((res) => res)
}
const deleteAwardURLFinalsubmiturl = awsLambdUrl + '/getdetails'
export function thankuFinalSubmit(postDataSubmit) {
  return axios.post(deleteAwardURLFinalsubmiturl, postDataSubmit)
    .then((data) => data)
    .then((res) => res)
}
const messagesend = awsLambdUrl + '/getdetails'
export function finalMeassegeSend(postDataMessage) {
  return axios.post(messagesend, postDataMessage)
    .then((data) => data)
    .then((res) => res)
}
export function getStateDetailsNew() {
  console.log(awsLambdUrl + '/getdetails?functionName=stateNew');
  return fetch(awsLambdUrl + '/getdetails?functionName=stateNew')
    .then(data => data.json())
    .then(res => res);
}
export function getUserAuthentication(functionName, username, password) {
  return fetch(awsLambdUrl + '/getdetails?functionName=' + functionName + '&username=' + username + '&password=' + password)
    .then((data) => data.json())
    .then((res) => res)
}
//   export function getawscredentials() {
//   console.log("aws",awsLambdUrl + '/getdetails?functionName=awsCredentials')
//   return fetch(awsLambdUrl + '/getdetails?functionName=awsCredentials')
//     .then(data => data.json())
//     .then(res => res);
// }


